export default __webpack_public_path__ + "static/media/find-icon.d4454fcd.svg";